module.exports = __webpack_public_path__ + "static/media/Workflow_hero.32b6e1b6.webp";